import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './ProductsDropdown.module.css';
import { Video, MessageSquare, TrendingUp, Database } from 'lucide-react';

const ProductsDropdown = () => {
    const navigate = useNavigate();

    const products = [
        {
            name: 'Unified Meeting Assistant',
            slug: '/products/meeting-assistant',
            icon: <Video className={styles.icon} />,
        },
        {
            name: 'Conversation Intelligence',
            slug: '/products/conversation-intelligence',
            icon: <MessageSquare className={styles.icon} />,
        },
        {
            name: 'Deal Intelligence & Forecasting',
            slug: '/products/deal-intelligence',
            icon: <TrendingUp className={styles.icon} />,
        },
        {
            name: 'Built-in CRM',
            slug: '/products/built-in-crm',
            icon: <Database className={styles.icon} />,
        }
    ];

    const handleLinkClick = (slug) => {
        navigate(slug);
    };

    return (
        <div className={styles.megaMenu}>
            <div className={styles.menuContent}>
                {products.map((item) => (
                    <div
                        key={item.slug}
                        className={styles.menuItem}
                        onClick={() => handleLinkClick(item.slug)}
                    >
                        <div className={styles.iconWrapper}>{item.icon}</div>
                        <div className={styles.itemText}>
                            <p className={styles.itemName}>{item.name}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ProductsDropdown;

